import { getModalByTemplate } from "./modal";

let modalOpenBtn = document.querySelector("[data-action=modal-cadeia-produtiva]")

if (modalOpenBtn) {
  document.querySelectorAll("[data-action=modal-cadeia-produtiva]").forEach(card => {
    card.addEventListener("click", function (option) {
      getModalByTemplate("escolha-cadeia-produtiva", { url: option.currentTarget.dataset.url });
    })
  });
}


